import { createSlice } from '@reduxjs/toolkit';
import Api from "services/api";

export const initialState = {
  translationDetails: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  popup: {
    show: false,
    item: {}
  }
};

export const translationDetailsSlice = createSlice({
  name: 'translationDetails',
  initialState,
  reducers: {
    setTranslationDetails: (state, { payload }) => {
      state.translationDetails = payload;
    },
    setError: (state, { payload }) => {
      state.error = payload;
    },
    setLoader: (state, { payload }) => {
      state.loader = payload;
    },
  }
});

// ✅ accept translation
export const acceptTranslationDetails = (id, data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));
  try {
    const json = await Api.acceptTranslationDetails(id, data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else {
      dispatch(setError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setLoader(false));
};

export const rejectTranslationDetails = (id, data, callback) => async (dispatch) => {
  dispatch(setError({}));
  dispatch(setLoader(true));

  try {
    const json = await Api.rejectTranslationDetails(id, data);

    console.log('Reject API response:', json);

    if (json.status >= 200 && json.status < 300) {
      if (callback) callback(true, json.data.message);
    } else {
      dispatch(setError(json.data));
      if (callback) callback(false, json.data.message);
    }
  } catch (error) {
    console.log('Reject API error:', error);
    if (callback) callback(false, 'Something went wrong while rejecting');
  }

  dispatch(setLoader(false));
};

export const fetchTranslationDetails = (token, callback) => async (dispatch) => {
  dispatch(setLoader(true));
  try {
    const result = await Api.fetchTranslationDetails(token);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setTranslationDetails(result.data.data));
      callback(true, result.data.message);
    } else {
      dispatch(setError(result.data));
      callback(false, result.data.message);
    }
  } catch (error) {
    console.log("error", error);
  }
  dispatch(setLoader(false));
};

export const { setTranslationDetails, setLoader, setError } = translationDetailsSlice.actions;

export default translationDetailsSlice.reducer;

export const translationDetailsSelector = (state) => state.translationDetails;
